//引入router
import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
    Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 引入页面
import layout from '../layout/layout.vue'
import index from '../views/index.vue'//首页
import center from '../views/center.vue'//个人中心
import content from '../views/content.vue'//内容页
import aboutHospital from '../views/aboutHospital.vue'//医院概况
import manageHospital from '../views/manageHospital.vue'//医政管理
import outpatient from '../views/outpatient.vue' //门诊服务
import exchange from '../views/exchange.vue' //对外交流
import manpower from '../views/manpower.vue' //人力资源
import educat from '../views/educat.vue' //科学教研
import discipline from '../views/discipline.vue' //纪检监察
import building from '../views/building.vue' //基础党建
import Nursing from '../views/Nursing.vue' //护理园地
import managequality from '../views/managequality.vue' //质量管理
import personMsg from '../views/personMsg.vue' //线上挂号
import registerOnline from '../views/registerOnline.vue' //线上挂号
import doctorTeam from '../views/doctorTeam.vue' //医生团队
// 存放路由数据
const routes = [
    {
        name:'layout',
        path: '/', 
        component: layout,
        redirect: '/index',
        children:[
            {
                name:'index',
                path: '/index', 
                component: index,
            },{
                name:'center',
                path: '/center', 
                component: center,
                
            },{
                name:'personMsg',
                path: '/personMsg', 
                component:personMsg
            },{
                name:'content',
                path: '/content', 
                component: content,
            },{
                name:'aboutHospital',
                path: '/aboutHospital', 
                component: aboutHospital,
            },{
                name:'manageHospital',
                path: '/manageHospital', 
                component: manageHospital,
            },{
                name:'registerOnline',
                path:'/registerOnline',
                component:registerOnline,
            },{
                name:'doctorTeam',
                path: '/doctorTeam', 
                component: doctorTeam,
            },{
                name:'outpatient',
                path: '/outpatient', 
                component: outpatient,
            },{
                name:'educat',
                path: '/educat', 
                component: educat,
            },{
                name:'exchange',
                path: '/exchange', 
                component: exchange,
            },{
                name:'discipline',
                path: '/discipline', 
                component: discipline,
            },{
                name:'manpower',
                path: '/manpower', 
                component: manpower,
            },{
                name:'building',
                path: '/building', 
                component: building,
            },{
                name:'Nursing',
                path: '/Nursing', 
                component: Nursing,
            },{
                name:'managequality',
                path: '/managequality', 
                component: managequality,
            }
        ]
    },
    
    
    
    
]

// 实例化路由数据
const router = new Router({
    routes,
     // 对于页面跳转，全部都返回到页面顶部。
  scrollBehavior(to, from, savedPosition) {
    to, from, savedPosition
    return { x: 0, y: 0 };
  },
})

// 标题
router.beforeEach((to, from, next) => {
	document.title = "利津县中心医院";
	next();
})

//抛出 
export default router